export const PRODUCT_STATUS = {
  cart: 'IN_CART',
  shelf: 'SHELF',
  validated: 'VALIDATED',
  readonly: 'READONLY'
}
